(function() {
  function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;
    try {
      const item = JSON.parse(itemStr);
      const now = new Date();
      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }
      return item.value;
    } catch (e) {
      return null;
    }
  }

  const selectedCountry = getWithExpiry('unze-selected-country');
  const isSelectCountryPage = window.location.pathname.includes('/pages/select-country');
  
  // Current Host check
  const currentHost = (window.location.hostname || "").toLowerCase();
  const isUKHost = currentHost === "unze.com.pk" || currentHost === "www.unze.com.pk";
  
  if (isUKHost) return;

  if (selectedCountry === 'Pakistan') {
    window.location.replace('https://unze.com.pk/');
    return;
  }

  if (selectedCountry === 'UK') {
    return;
  }

  // If no selection exists, check for UK visitor
  let zone = "";
  try {
    zone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (_) {}

  // UK visitor detection (using user's logic)
  if (zone === "Asia/Karachi") {
    if (!isSelectCountryPage) {
      window.location.replace('/pages/select-country');
    }
  }
})();
